import { getUserCreditsTask, getNotice, getCreditConfig } from '@/utils/service'
import { getCashUserInfo } from '@/request/cash'
import {
  NOT_INCLUDE,
  NEWER_TASK,
  DAY_TASK,
  SPECIAL_TASK,
  VIP_TASK,
} from '@/utils/constant'

export async function getTaskInfo({ state, commit }) {
  try {
    const swi = state.devicesInfo && state.devicesInfo.pushSwitch

    const data = await getUserCreditsTask(
      [
        ...NOT_INCLUDE,
        ...NEWER_TASK,
        ...DAY_TASK,
        ...SPECIAL_TASK,
        ...VIP_TASK,
      ].join(','),
      swi
    )
    commit('setTaskInfo', data)
  } catch (error) {
    console.log('getUserCreditsTask', error)
  }
}

export async function queryCashUserInfo({ state, commit }) {
  try {
    const res = await getCashUserInfo()
    if (res.code === 200) {
      commit('setCashUserInfo', res.data)
    } else {
      commit('setCashUserInfo', {})
    }
  } catch (error) {
    console.log(error)
  }
}

/**
 * 获取notice 数据
 */
export async function getNoticeAction({ state, commit }) {
  try {
    const res = await getNotice({ position: 0 })
    if (Array.isArray(res) && res.length) {
      commit('setNotices', res)
    }
  } catch (error) {
    console.log(res)
  }
}

export async function getShowState({ state, commit }) {
  try {
    const res = await getCreditConfig()
    commit('setShowState', res.state_bit_set)
  } catch (res) {
    console.log(res)
  }
}
